/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as CookieConsent from './trans-website-chat-cookieconsent';

export const EndChatQuestion = 'Website.Chat.EndChatQuestion';
export const EndChatButtonYesCaption = 'Website.Chat.EndChatButtonYesCaption';
export const EndChatButtonNoCaption = 'Website.Chat.EndChatButtonNoCaption';
export const EndChatButtonCaption = 'Website.Chat.EndChatButtonCaption';
export const ButtonText = 'Website.Chat.ButtonText';
export const Home = 'Website.Chat.Home';
export const Advisor = 'Website.Chat.Advisor';
export const CustomerService = 'Website.Chat.CustomerService';
export const Headline = 'Website.Chat.Headline';
export const AdvisorHeader = 'Website.Chat.AdvisorHeader';
export const AdvisorDescription = 'Website.Chat.AdvisorDescription';
export const AdvisorButton = 'Website.Chat.AdvisorButton';
export const CustomerServiceHeader = 'Website.Chat.CustomerServiceHeader';
export const CustomerServiceDescription = 'Website.Chat.CustomerServiceDescription';
export const CustomerServiceButton = 'Website.Chat.CustomerServiceButton';
export const AdvisorChatUnavailable = 'Website.Chat.AdvisorChatUnavailable';
export const LiveLabel = 'Website.Chat.LiveLabel';
export const OnlineNow = 'Website.Chat.OnlineNow';
export const DefaultGetAdviceDesktopText = 'Website.Chat.DefaultGetAdviceDesktopText';
export const DefaultGetAdviceMobileText = 'Website.Chat.DefaultGetAdviceMobileText';
export const PdpDefaultGetAdviceDesktopText = 'Website.Chat.PdpDefaultGetAdviceDesktopText';
export const PdpDefaultGetAdviceMobileText = 'Website.Chat.PdpDefaultGetAdviceMobileText';
export const PdpHairStylistGetAdviceDesktopText = 'Website.Chat.PdpHairStylistGetAdviceDesktopText';
export const PdpHairStylistGetAdviceMobileText = 'Website.Chat.PdpHairStylistGetAdviceMobileText';
export const PdpPharmaGetAdviceDesktopText = 'Website.Chat.PdpPharmaGetAdviceDesktopText';
export const PdpPharmaGetAdviceMobileText = 'Website.Chat.PdpPharmaGetAdviceMobileText';
export const SpecificGetAdviceDesktopText = 'Website.Chat.SpecificGetAdviceDesktopText';
export const SpecificGetAdviceMobileText = 'Website.Chat.SpecificGetAdviceMobileText';
export const AskUs = 'Website.Chat.AskUs';
